import React from 'react';
import clsx from 'clsx';
import PropTypes from 'prop-types';
import {makeStyles} from '@material-ui/styles';
import {
    Button,
    Card,
    CardContent,
    Grid,
    FormControl,
    InputLabel,
    MenuItem,
    Select,
} from '@material-ui/core';
import {getAllSubCategory} from '../../../../apis/api';

const useStyles = makeStyles((theme) => ({
    root: {},
    formControl: {
        marginRight: theme.spacing(1),
    },
    select: {},
    icon: {
        marginRight: '12px',
    },
    selectEmpty: {
        marginTop: theme.spacing(2),
    },
}));

const Error = () => (<div>Error</div>);

const Filter = props => {
    const {className, categoryList, changeCategory, onSubmit, ...rest} = props;
    const classes = useStyles(props);

    const errorHandler = () => <Error />;

    // 대 카테고리 선택
    const parentCategoryList = categoryList;
    const [parentCategory, setParentCategory] = React.useState('');
    const handleParentCategoryChange = event => {
        setParentCategory(event.target.value);
        setSubCategory('');
        setSubCategoryList([]);

        if (!event.target.value) return;

        const {code, name} = parentCategoryList.find(cate => cate.code === event.target.value);
        changeCategory({
            parentCode: code,
            parentName: name,
            code: '',
            name: ''
        });
        getAllSubCategory(event.target.value)
            .then((res) => {
                if (res.statusCode === 0) return errorHandler();

                setSubCategoryList(res);
            }).catch(() => {
                return errorHandler();
            });
    };

    // 중 카테고리
    const [subCategoryList, setSubCategoryList] = React.useState([]);
    const [subCategory, setSubCategory] = React.useState('');
    const handleSubCategoryChange = event => {
        const result = subCategoryList.find(cate => cate.code === event.target.value);

        setSubCategory(event.target.value);
        changeCategory(result);
    };

    const submitHandler = (e) => {
        e.preventDefault();

        onSubmit();
    };

    return (
        <Card
            {...rest}
            className={clsx(classes.root, className)}
        >
            <CardContent>
                <Grid
                    alignItems="flex-end"
                    container
                    spacing={2}
                >
                    <Grid
                        item
                        md={5}
                        sm={5}
                        xs={12}
                    >
                        <FormControl
                            className={classes.formControl}
                            fullWidth
                        >
                            <InputLabel
                                id="parent-category-label"
                                shrink
                            >category1</InputLabel>
                            <Select
                                classes={{
                                    icon: classes.icon,
                                }}
                                displayEmpty
                                id="parent-category"
                                labelId="parent-category-label"
                                onChange={handleParentCategoryChange}
                                value={parentCategory}
                            >
                                <MenuItem value="">
                                    <em>select category</em>
                                </MenuItem>
                                {parentCategoryList.map(category => (
                                    <MenuItem
                                        key={category.code}
                                        value={category.code}
                                    >
                                        {category.name}
                                    </MenuItem>
                                ))}
                            </Select>
                        </FormControl>
                    </Grid>

                    <Grid
                        item
                        md={5}
                        sm={5}
                        xs={12}
                    >
                        <FormControl
                            className={classes.formControl}
                            fullWidth
                        >
                            <InputLabel
                                id="sub-category-label"
                                shrink
                            >category2</InputLabel>
                            <Select
                                classes={{
                                    icon: classes.icon,
                                }}
                                displayEmpty
                                id="sub-category"
                                labelId="sub-category-label"
                                onChange={handleSubCategoryChange}
                                value={subCategory}
                            >
                                <MenuItem value="">
                                    <em>select category</em>
                                </MenuItem>
                                {subCategoryList.map(category => (
                                    <MenuItem
                                        key={category.code}
                                        value={category.code}
                                    >
                                        {category.name}
                                    </MenuItem>
                                ))}
                            </Select>
                        </FormControl>
                    </Grid>

                    <Grid
                        item
                        md={2}
                        sm={2}
                        xs={12}
                    >
                        <Button
                            color="primary"
                            fullWidth
                            onClick={submitHandler}
                            size="small"
                            variant="outlined"
                        >
                            apply
                        </Button>
                    </Grid>
                </Grid>
            </CardContent>
        </Card>
    );
};

Filter.propTypes = {
    categoryList: PropTypes.array,
    changeCategory: PropTypes.func,
    className: PropTypes.string,
};

export default Filter;
